import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'pxc-card-button',
  templateUrl: './card-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class:
      'flex h-full w-full gap-6 rounded-3xl bg-background-primary p-6 text-left ring-1 ring-border-normal transition hover:shadow-lg hover:ring-0 focus:shadow-lg focus:ring-0 cursor-pointer',
  },
  imports: [TuiIcon],
})
export class CardButtonComponent {
  @Input() title: string;
  @Input() description: string;
  @Input() icon: string;
}
